import { getValidResponseBody, staticApi } from '../api';

/**
 * Validates if a given slug is a valid main category
 * Use this async function in data loaders only
 * @param {string} slug - The slug to validate
 * @returns {Promise<boolean>} - True if the slug is a valid main category, false otherwise
 */
export const isValidMainCategory = async (slug) => {
  if (!slug) return false;
  const mainCategoriesResp = await staticApi.getShopsMainCategories();
  const mainCategories = getValidResponseBody(mainCategoriesResp);
  return mainCategories.categories.some((category) => category.slug === slug);
};
